var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../../styled';
// import { BaseProps } from "@mui/material/OverridableComponent";
import { DangerZoneItemAction } from '../danger-zone-item-action';
import { TitleBlock } from '../../title-block';
var dangerZoneItemComponentName = 'QuantumDangerZoneItem';
export var Root = styled('li', {
    name: dangerZoneItemComponentName,
    slot: 'Root',
})(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: theme.tokens.color_bg_state_danger_subtle,
        color: theme.tokens.color_fg_on_state_danger_subtle,
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        borderRadius: theme.shape.borderRadius,
    });
});
export var StyledTitleBlock = styled(TitleBlock, {
    name: dangerZoneItemComponentName,
    slot: 'TitleBlock',
})(function (_a) {
    var theme = _a.theme;
    return ({
        flex: 1,
        marginRight: theme.spacing(3),
    });
});
export var ActionContainer = styled('div', {
    name: dangerZoneItemComponentName,
    slot: 'ActionContainer',
})(function () { return ({
    flexShrink: 0,
}); });
export var DangerZoneItem = React.forwardRef(function (props, ref) {
    var className = props.className, title = props.title, _a = props.titleTypographyProps, titleTypographyProps = _a === void 0 ? {} : _a, description = props.description, _b = props.descriptionTypographyProps, descriptionTypographyProps = _b === void 0 ? {} : _b, _c = props.action, action = _c === void 0 ? {} : _c, children = props.children, rootProps = __rest(props, ["className", "title", "titleTypographyProps", "description", "descriptionTypographyProps", "action", "children"]);
    return (React.createElement(Root, __assign({ ref: ref, className: className, component: "li" }, rootProps),
        React.createElement(StyledTitleBlock, { gutter: 0.5, title: title, titleTypographyProps: __assign({ color: 'inherit' }, titleTypographyProps), description: description, descriptionTypographyProps: __assign({ color: 'inherit' }, descriptionTypographyProps) }),
        React.createElement(ActionContainer, null,
            React.createElement(DangerZoneItemAction, __assign({}, action), action.children || action.label))));
});
